/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePlayIcon32Regular = forwardRef('MediaUiCirclePlayIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.442 9.217c-1.066-.66-2.442.106-2.442 1.36v10.846c0 1.254 1.376 2.02 2.442 1.36l8.76-5.423a1.6 1.6 0 0 0 0-2.72l-8.76-5.423ZM13 20.705v-9.41L20.6 16 13 20.705Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16Z" })));
});
